import { useContext } from 'react';

import { ArticlePageTempHeaderContext } from '../../components/article-page/article-page-temp-header/article-page-temp-context/article-page-temp-context';

export const useArticlePageTempHeaderContext = () =>
    useContext(ArticlePageTempHeaderContext);
